import { render } from "./heading.vue?vue&type=template&id=fe31aa24"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"

import "./heading.vue?vue&type=style&index=0&id=fe31aa24&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/heading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe31aa24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe31aa24', __exports__)) {
    console.log('reload')
    api.reload('fe31aa24', __exports__)
  }
  
  module.hot.accept("./heading.vue?vue&type=template&id=fe31aa24", () => {
    console.log('re-render')
    api.rerender('fe31aa24', render)
  })

}


export default __exports__